export class Routes {

  public static readonly login = '/auth/login';
  public static readonly forgotPassword = '/auth/forgot-password';

  public static readonly home = '/home';
  public static readonly dashboard = '/home/dashboard';

  public static readonly disbursementNavigator = '/home/disbursement';
  public static readonly cashAdvance = '/home/disbursement/cash-advance';
  public static readonly reimbursement = '/home/disbursement/reimbursement';
  public static readonly liquidation = '/home/disbursement/liquidation';
  public static readonly disbursementList = '/home/disbursement/list';

  public static readonly account = '/home/account';
  public static readonly userProfile = '/home/account/user-profile';
  public static readonly userList = '/home/account/list';
  public static readonly userAccess = '/home/account/access';
  public static readonly manageApprover = '/home/account/manage-approvers';
  public static readonly manageChartOfAccounts = '/home/account/manage-chart-of-accounts';
  public static readonly userAudits = '/home/account/audits';

  public static readonly accountPayable = '/home/account-payabale';
  public static readonly accountReceivable = '/home/account-receivable';

  public static readonly generalLedger = '/home/general-ledger';

  public static readonly manageClients = '/home/manage-clients';

  public static readonly err404 = '/auth/error/404';
  public static readonly err500 = '/auth/error/500';

  public static readonly tabName = {
    disburesement: '/disburesement',
    prs: '/prs',
  }

  private constructor() { }
}